import React from "react";
import { connect } from "react-redux";
import { compose, lifecycle } from "recompose";
import { map, sortBy, filter, size, invoke, concat } from "lodash";

import List from "react-md/lib/Lists/List";
import ListItem from "react-md/lib/Lists/ListItem";
import Card from "react-md/lib/Cards/Card";
import CardText from "react-md/lib/Cards/CardText";
import Button from "react-md/lib/Buttons/Button";
import {array_utilities} from "../../Atollon/utilities/array_utilities";
import {TouchTable, TouchTable_alignColumnRight, TouchTableHeader} from "../../AtollonTheme/ReactElements";
import { isAdmin } from "../../utils";
import { canUserEditThisOrganization } from "../../Atollon/CanUserEditThisOrganization";
import {getJSONOrNull} from "../../actions/OauthApplicationsActions";
import {getApiPrefix_touch} from "../../constants";

let oauthApplicationsList = [];

function log()
{
    console.log.apply( null, concat( ['%cOauthApplications', 'color:blue'], arguments ));
}

/*
  [{
        "clientType": "client",
       "clientId": "xxxx.atollon.com",
       "url": "https://xxxx.atollon.com/yyyyy"
  }, ... ]
 */
const OauthApplications = ( reduxPropertiesAsDictionary ) =>
{
    let { state } = reduxPropertiesAsDictionary;

    // alert( oauthApplicationsList.length );

    let admin;
    log({ state });
    if( state && state.app )
    {
        log( 'state.app.role', state.app.role );
        admin = isAdmin( state.app.role );
    }
    else
    {
        admin = false;
    }

    if( size( oauthApplicationsList ))
    {
            return (
                <div>
                    <TouchTableHeader
                        title={"ERP Bridge"}
                        titleNumber={ size( oauthApplicationsList ) }
                    />
                    <TouchTable
                        headerAsList={["clientType", "clientId", "url", TouchTable_alignColumnRight( "Akce" )]}
                        elementsAsList={
                            map( sortBy( oauthApplicationsList, ['clientType'] ), ( item, i ) =>
                            {
                                let url = item.url;

                                if( !url )
                                {
                                    url = ''; // backend generates url
                                    //
                                    // if( item.clientId )
                                    // {
                                    //     url = "https://" + item.clientId + "/erpbridge";
                                    // }
                                }
                                return ([
                                    item.clientType,
                                    item.clientId,
                                    url,
                                    (
                                        <div>
                                            {url ?
                                                    <div style={{display: 'inline-block', position: 'relative', margin: '0 0 0 5px'}}>

                                                        <Button flat
                                                                primary
                                                                label="Otevřít v novém okně"
                                                                className="btn btn-primary touchButton-6"
                                                        />

                                                        <a
                                                            href={ url }
                                                            target="_blank"
                                                            style={

                                                            // CSS: whole card is clickable
                                                            {
                                                                textDecoration: 'none',
                                                                position: 'absolute',
                                                                width: '100%',
                                                                height: '100%',
                                                                background: 'red',
                                                                opacity: 0,
                                                                left: 0,
                                                                top: 0,
                                                                zIndex: 1
                                                            }}
                                                        />
                                                    </div>

                                                    : null
                                                }
                                        </div>
                                    )
                                ]);
                            })
                        }
                    />
                </div>
            );
    }
    else
    {
        return (
            <div />
        );
    }
};

export default compose(
    connect(
        (state) => {
            return (
                {
                    state: state
                }
            );
        },
        null
    ),
    lifecycle({
        async componentWillMount()
        {
            let list = await getJSONOrNull({ url: `${getApiPrefix_touch()}/oauthApplications?type=erpbridge`, doNotAlertErrors: true });
            if( list )
            {
                // let validList = filter( list, ( item ) => item.url );
                let validList = list;
                oauthApplicationsList = validList;
            }
            else
            {
                oauthApplicationsList = [];
            }

        }
    })
)(OauthApplications);



// WEBPACK FOOTER //
// ./src/components/organizations/OauthApplications.js